import { useHits, UseHitsProps } from "react-instantsearch"

import Card from "../../../components/card"
import { DocumentData } from "../../utils/types"

export default function CardGrid(props: UseHitsProps<DocumentData>) {
  const { items } = useHits(props)

  /* No results */
  if (items.length === 0) return <p className="opacity-70">No results found</p>

  /* Results found */
  return (
    <ul className="grid grid-cols-6 desktop:grid-cols-12 gap-24">
      {items.map((item: DocumentData, index: number) => {
        const {
          heading,
          // description,
          path,
          image,
          logo,
          entity,
          type,
          primary_theme,
          duration_mins,
        } = item
        const theme = primary_theme || "General"

        return (
          <li key={path} className="col-span-full tablet:col-span-3">
            {entity == "case_study" ? (
              <Card
                path={path}
                description={heading}
                image={image}
                logo={logo}
                hideCta={true}
                index={index}
                centerAlign={true}
                mask={true}
                ctaLabel="View case study"
              />
            ) : (
              <Card
                heading={heading}
                path={path}
                image={image}
                ctaLabel={`View ${type.replaceAll("_", " ")}`}
                hideCta={true}
                theme={theme}
                durationMins={duration_mins}
                resourceType={type}
              />
            )}
          </li>
        )
      })}
    </ul>
  )
}
